import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { QRCodeCard } from '@/components/QRCodeCard'
import { useGetMessageAndLinkToShareMyProfile } from '@/hooks/useGetMessageAndLinkToShareMyProfile'
import { useDeviceShare } from '@/hooks/useDeviceShare'
import { ArrowUpUnderline } from '@/assets/icons'

export const ShareQRCode: React.FC = () => {
  const { t } = useTranslation()
  const { share } = useDeviceShare()

  const { message, linkShareMyProfile, userProfile } =
    useGetMessageAndLinkToShareMyProfile()

  const handleShare = () => {
    share({ message })
  }

  // Заглушка для тестирования без аутентификации
  const mockProfile = {
    fullName: 'Grigory1',
    first_name: 'Sharapov1',
    username: 'ivanspiridonov',
    user_id: 'mock-user-id',
  }

  const profileToUse = userProfile || mockProfile
  const linkToUse = userProfile
    ? linkShareMyProfile
    : 'https://kemapp.io/user-profile/mock-user-id'

  if (!profileToUse) {
    return (
      <BaseView center justify="center" className="px-6" gap={32}>
        <BaseText className="text-white/80 text-lg">
          {'Loading profile...'}
        </BaseText>
      </BaseView>
    )
  }

  return (
    <BaseView gap={32}>
      {/* QR Code Card */}
      <BaseView center>
        <QRCodeCard value={linkToUse} size={230} />
      </BaseView>

      {/* Информация о пользователе */}
      <BaseView center>
        <BaseText
          style={{ fontSize: 24 }}
          className="text-text-primary font-bold text-center"
        >
          {profileToUse.fullName || profileToUse.first_name || 'User'}
        </BaseText>
        <BaseText
          fontFamily="semibold"
          className="text-lg text-center"
          style={{ color: '#7B91FF' }}
        >
          {profileToUse.username || 'user'}
        </BaseText>
      </BaseView>

      {/* Кнопка поделиться */}
      <BaseView center>
        <BaseView
          center
          justify="center"
          className="bg-[#242426] rounded-full"
          style={{
            width: '84px',
            height: '84px',
          }}
        >
          <button
            onClick={handleShare}
            className="flex items-center justify-center transition-all duration-200 hover:opacity-80 rounded-full"
            style={{
              width: '84px',
              height: '84px',
            }}
          >
            <ArrowUpUnderline size={24} color="white" />
          </button>
        </BaseView>
      </BaseView>
    </BaseView>
  )
}
